import { SignInRoute } from "./SignInRoute";
import { SignInSplitLayout } from "./layouts/SignInSplitLayout";
import { SignInForm } from "./SignInForm";

export function SignInSplitPage() {
  return (
    <SignInRoute>
      <SignInSplitLayout>
        <SignInForm />
      </SignInSplitLayout>
    </SignInRoute>
  );
}
